import { render, staticRenderFns } from "./AlertaUrgentes.vue?vue&type=template&id=b7d8a70a"
import script from "./AlertaUrgentes.vue?vue&type=script&lang=js"
export * from "./AlertaUrgentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports